<template>
    <div class="OBSControl">
        <!--<button @click="sendSomething">Klick</button>-->
        <form v-if="obs === undefined" action="#" @submit="connectOBS">
            <!--<div><input type="checkbox" v-model="obsUseProxy" id="obsUseProxy" :disabled="!!obsUseWSS" /><label for="obsUseProxy">Use Proxy</label></div>-->
            <!--<div v-show="!obsUseProxy"><input type="checkbox" v-model="obsUseWSS" id="obsUseWSS" /><label for="obsUseWSS">Use Secure Connection</label></div>-->
            <!--<div><input type="checkbox" v-model="obsUseWSS" id="obsUseWSS" :disabled="!!obsUseProxy" /><label for="obsUseWSS">Use Secure Connection</label></div>-->
            <div><input type="checkbox" v-model="obsUseWSS" id="obsUseWSS" :disabled="!!obsUseWSSOnly" /><label for="obsUseWSS">Use Secure Connection</label></div>
            <div v-if="obsUseWSSOnly">Um OBS-Control über eine unsichere Verbindung nutzen zu können, muss die Seite über eine unsichere Verbindung geladen werden! Ein entsprechender Link steht im Hauptbereich zur Verfügung.</div>
            <input ref="host" type="text" label="Host" v-model="obsHost" placeholder="Host:Port" /><br />
            <input ref="password" type="password" v-model="obsPassword" label="Password" placeholder="Passwort" />
            <input type="submit" label="Verbinden" value="Verbinden" />
            <div class="obsError">{{obsError}}</div>
        </form>
        <div v-else>
            <a href="#" @click="disconnectOBS" class="controlButton">
                <font-awesome-icon :icon="['fas', 'unlink' ]" class="icon" />
                <div class="caption">Disconnect</div>
            </a>
            <a href="#" @click="reconnectOBS" class="controlButton">
                <font-awesome-icon :icon="['fas', 'sync' ]" class="icon" />
                <div class="caption">Reconnect</div>
            </a>
            <a href="#" @click="toggleStudioMode" :class="'controlButton' + (studioMode ? ' active' : '')">
                <font-awesome-icon :icon="['fas', 'square' ]" class="icon" style="padding-right: 0.1rem;"/>
                <font-awesome-icon :icon="['fas', 'square' ]" class="icon" />
                <div class="caption">Studiomode</div>
            </a>
            <!--<button @click="disconnectOBS" :icon="['fas', 'unlink']">Disconnect</button>
            <button @click="reconnectOBS">Reconnect</button>-->
        </div>
        <div class="specialSources">
            <a href="#" v-for="specialSource in specialSources" :key="specialSource.name" v-if="specialSource.name" :data-source="specialSource.name" @click="specialSourceClick" :class="'specialSource' + (specialSource.muted ? ' muted' : '')">
                <div v-if="specialSource.muted || (!specialSource.volume)" class="icon mute">
                    <font-awesome-icon :icon="['fas', 'volume-mute' ]" class="icon mute" />
                </div>
                <div v-else-if="ratioToDB(specialSource.volume) > -10" class="icon volume-up">
                    <font-awesome-icon :icon="['fas', 'volume-up' ]" />
                </div>
                <div v-else class="icon volume-down">
                    <font-awesome-icon :icon="['fas', 'volume-down' ]" />
                </div>
                <div class="name">{{specialSource.name}}</div>
                <div class="volume">
                    <!--                    {{ specialSource.volume ? ((ratioToDB(specialSource.volume) > -10 && ratioToDB(specialSource.volume) < 10) ? '&numsp;' : '') + ((ratioToDB(specialSource.volume) > 0 ? '+' : (ratioToDB(specialSource.volume) == 0 ? '-' : '')) + Math.round(ratioToDB(specialSource.volume) * 10) / 10 + (Math.round(ratioToDB(specialSource.volume)) == Math.round(ratioToDB(specialSource.volume) * 10) / 10 ? '.0' : '')) : '-inf' }} dB-->
                    {{ specialSource.volume ? niceDB(ratioToDB(specialSource.volume)) : '-inf' }} dB
                </div>
            </a>
        </div>
        <div class="scenes">
            <a href="#" v-for="scene in scenes" :key="scene.name" :class="'scene' + (scene.name == currentScene ? ' currentScene': '') + (((scene.name == previewScene) && (studioMode)) ? ' previewScene' : '') + ((scene.name == loadScene) ? ' loading' : (((scene.name == loadPreviewScene) && (studioMode)) ? ' loadingPreview' : ''))" :data-scene="scene.name" @click="sceneClick">
                <img v-if="scene.screenshot" :src="scene.screenshot" class="sceneScreenshot" />
                {{scene.name}}
            </a>
        </div>
    </div>
</template>

<script>
    import OBSWebSocket from 'obs-websocket-js';
    //import jQuery from 'jquery';
    //import ProxySenderJS from './ProxySenderJS.js';
    //import uniqueId from 'lodash.uniqueid';

    export default {
        name: 'OBSControl',
        props: {
            tick: { type: Number, required: false, default: 0 },
        },
        data: function () {
            return {
                scenes: [],
                specialSources: {
                    'desktop-1': {},
                    'desktop-2': {},
                    'mic-1': {},
                    'mic-2': {},
                    'mic-3': {}
                },
                sources: [],
                obs: undefined,
                obsHost: '',
                obsPort: '',
                obsPassword: '',
                obsError: '',
                //obsUseProxy: false,
                obsUseWSS: window.isSecureContext && location.hostname !== "localhost" && location.hostname !== "127.0.0.1",
                obsUseWSSOnly: window.isSecureContext && location.hostname !== "localhost" && location.hostname !== "127.0.0.1",
                currentScene: undefined,
                previewScene: undefined,
                loadScene: undefined,
                loadPreviewScene: undefined,
                studioMode: false,
                videoInfo: undefined,
                proxyWindow: undefined,
            };
        },
        methods: {
            //hostKeyDown: function (event) {
            //    if (event.key == ':') {
            //        event.preventDefault();
            //        this.$refs.port.focus();
            //    }
            //},
            //sendSomething: function () {
            //    var url = process.env.BASE_URL + 'WS-Proxy/register.php';
            //    jQuery.ajax({
            //        url: url,
            //        context: this,
            //    })
            //        .done(function (data, textStatus) {
            //            console.log('Send Something: ' + textStatus + ' -> ' + JSON.stringify(data));
            //        })
            //        .fail(function (jqXHR, textStatus, errorThrown) {
            //            console.log('Send Something: ' + textStatus + ' -> ' + errorThrown);
            //        });
            //},
            connectOBS: function (event) {
                if (event) event.preventDefault();
                this.obsError = '';
                //new Promise((resolve, reject) => {
                new Promise((resolve) => {
                    //if (this.obsUseProxy) {
                    //    this.obs = new ProxySenderJS(process.env.BASE_URL + 'WS-Proxy/');
                    //    this.obs.register().then(function (data) {
                    //        let proxy = data.proxy;
                    //        let receiver = data.receiver;
                    //        //let url = ([this.$router.resolve('proxyReceiver')['href']].replace(/^https\:\/\//i, 'http://')+'?insecure').replace(/#(.*)\?insecure$/,'?insecure#$1').replace('/\?(.*)\?insecure(#.*)$/','?$1&insecure$2');
                    //        let x = this.$router.resolve({ name: 'proxyReceiver', params: { url: process.env.BASE_URL + 'WS-Proxy/', proxy: proxy, receiver: receiver }, query: { insecure: null } });
                    //        let url = ((document.location.href.replace(/\/#.*$/, '') + '/' + (x.href.substring(0, 1) === '#' ? '?insecure' : '') + x.href).replace(/^https:\/\//i, 'http://').replace(/([^:])\/\//gi, '$1/'));
                    //        this.proxyWindow = window.open(url, uniqueId('ProxyReceiver'), 'width=100,height=100');
                    //        resolve();
                    //    }.bind(this),
                    //        function (reason) {
                    //            this.obsError = "Connecting to OBS-Proxy failed, reason: " + reason;
                    //            this.obs = undefined;
                    //            reject(reason);
                    //        }.bind(this));
                    //} else {
                    this.obs = new OBSWebSocket();
                    resolve();
                    //}
                }).then(function () {
                    var options = {
                        address: this.obsHost,
                        //secure: this.obsUseWSS && (!this.obsUseProxy),
                        secure: this.obsUseWSS || this.obsUseWSSOnly,
                    };
                    if (this.obsPassword != '') {
                        options.password = this.obsPassword;
                    }
                    this.obs.connect(options).then(function () {
                        this.obs.send('GetSceneList').then(function (data) {
                            this.scenes = data.scenes;
                            this.takeScreenShots(64);
                        }.bind(this));
                        this.obs.send('GetSourcesList').then(function (data) {
                            this.sources = data.sources;
                            this.obs.send('GetSpecialSources').then(function (data) {
                                Object.entries(data).forEach(entry => {
                                    const [key, value] = entry;
                                    if (this.specialSources[key] !== undefined) {
                                        this.sources.forEach(source => {
                                            if (source.name === value) {
                                                this.specialSources[key] = source;
                                                this.obs.send('GetVolume', { source: source.name }).then(function (data) {
                                                    this.$set(source, 'volume', data.volume);
                                                    this.$set(source, 'muted', data.muted);
                                                }.bind(this));
                                            }
                                        });
                                    }
                                });
                            }.bind(this));
                        }.bind(this));
                        this.obs.send('GetCurrentScene').then(function (data) {
                            this.currentScene = data.name;
                        }.bind(this));
                        this.obs.send('GetStudioModeStatus').then(function (data) {
                            this.studioMode = data.studioMode;
                        }.bind(this));
                        this.obs.on('SwitchScenes', function (data) {
                            this.currentScene = data.sceneName;
                            if (this.loadScene == this.currentScene) {
                                this.loadScene = undefined;
                            }
                        }.bind(this));
                        this.obs.on('PreviewSceneChanged', function (data) {
                            this.previewScene = data.sceneName;
                            if (this.loadPreviewScene == this.previewScene) {
                                this.loadPreviewScene = undefined;
                            }
                        }.bind(this));
                        this.obs.on('StudioModeSwitched', function (data) {
                            this.studioMode = data.newState;
                        }.bind(this));
                        this.obs.on('ScenesChanged', function (data) {
                            this.scenes = data.scenes;
                            this.takeScreenShots(64);
                            this.loadPreviewScene = this.loadScene = undefined;
                            this.obs.send('GetCurrentScene').then(function (data) {
                                this.currentScene = data.name;
                            }.bind(this));
                            this.obs.send('GetPreviewScene').then(function (data) {
                                this.previewScene = data.name;
                            }.bind(this));
                        }.bind(this));
                        this.obs.on('SourceVolumeChanged', function (data) {
                            this.sources.forEach(source => {
                                if (source.name === data.sourceName) {
                                    this.$set(source, 'volume', data.volume);
                                }
                            });
                        }.bind(this));
                        this.obs.on('SourceMuteStateChanged', function (data) {
                            this.sources.forEach(source => {
                                if (source.name === data.sourceName) {
                                    this.$set(source, 'muted', data.muted);
                                }
                            });
                        }.bind(this));
                    }.bind(this), function (error) {
                        console.log(error);
                        this.obsError = error.error;
                        this.obs = undefined;
                    }.bind(this));
                }.bind(this));
            },
            disconnectOBS: function () {
                let p = this.obs.disconnect();
                this.proxyWindow = undefined;
                this.obs = undefined;
                this.scenes = [];
                this.sources = [];
                this.specialSources = {
                    'desktop-1': {},
                    'desktop-2': {},
                    'mic-1': {},
                    'mic-2': {},
                    'mic-3': {}
                };
                if (this.proxyWindow && (p instanceof Promise)) {
                    p.then(function () {
                        if (this.proxyWindow) {
                            this.proxyWindow.close();
                        }
                    }.bind(this));
                    return p;
                }
                return false;
            },
            reconnectOBS: function () {
                let p = this.disconnectOBS();
                if (p instanceof Promise) {
                    p.then(function () { this.connectOBS(); }.bind(this));
                } else {
                    this.connectOBS();
                }
            },
            dBToRatio: function (dB) {
                return 10 ^ (dB / 10);
            },
            ratioToDB: function (ratio) {
                return 20 * Math.log10(ratio);
            },
            niceDB: function (dB) {
                var ret = '';
                var roundDB = Math.round(dB * 10) / 10;
                if (roundDB == 0) {
                    ret = '-';
                }
                else if (roundDB > 0) {
                    ret = '+';
                }
                ret += roundDB;
                if (Math.round(dB) == roundDB) {
                    ret += '.0';
                }
                if (roundDB > -10 && roundDB < 10) {
                    ret = '\u2007' + ret;
                }
                return ret;
            },
            toggleStudioMode: function () {
                var command = 'ToggleStudioMode';
                this.obs.send(command, {});
            },
            specialSourceClick: function (event) {
                event.preventDefault();
                var target = event.target.closest('.specialSource');
                if (target === null) return;
                var command = 'ToggleMute';
                this.obs.send(command, { 'source': target.dataset.source });
            },
            sceneClick: function (event) {
                event.preventDefault();
                var target = event.target.closest('.scene');
                if (target === null) return;
                var command = 'SetCurrentScene';
                if (this.studioMode) {
                    if (target.dataset.scene == this.previewScene) {
                        command = 'TransitionToProgram';
                        this.loadScene = target.dataset.scene;
                    } else {
                        command = 'SetPreviewScene';
                        this.loadPreviewScene = target.dataset.scene;
                    }
                } else {
                    this.loadScene = target.dataset.scene;
                }
                this.obs.send(command, { 'scene-name': target.dataset.scene });
            },
            takeScreenShots: function (height = 0) {
                if ((height < 0)) return;
                if (!this.videoInfo) {
                    this.obs.send('GetVideoInfo').then(function (height, data) {
                        this.videoInfo = data;
                        this.takeScreenShots(height);
                    }.bind(this, height), function (error) {
                        console.log(error);
                    });
                    return;
                }
                //                var width;
                //if (!height || height > this.videoInfo.baseHeight) {
                //    height = this.videoInfo.baseHeight;
                //    width = this.videoInfo.baseWidth;
                //} else {
                //    width = Math.floor(this.videoInfo.baseWidth / this.videoInfo.baseHeight * height);
                //}
                this.obs.send('GetVersion').then(function (data) {
                    console.log(data);
                }.bind(this));
                var options = { embedPictureFormat: 'png' };
                if (height) options.height = height;
                for (var scene in this.scenes) {
                    options.sourceName = this.scenes[scene].name;
                    this.obs.send('TakeSourceScreenshot', options).then(function (scene, data) {
                        this.$set(scene, 'screenshot', data.img);
                    }.bind(this, this.scenes[scene]));
                }
            },
        },
        watch: {
            studioMode: function (studioMode) {
                if (studioMode) {
                    this.obs.send('GetPreviewScene').then(function (data) {
                        this.previewScene = data.name;
                    }.bind(this));
                } else {
                    this.previewScene = undefined;
                    this.loadPreviewScene = undefined;
                }
            },
            tick: function () {
                this.takeScreenShots(64);
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import '../scss/theme.scss';

    .OBSControl {
        height: 100%;
        width: 100%;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .controlButton {
        border: 4px solid $currentSceneBG;
        border-radius: 10px;
        padding: 5px;
        margin-bottom: 5px;
        overflow: hidden;
        /*width: 2.5rem;*/
        /*height: 2.5rem;*/
        display: inline-block;
        margin: 5px 5px 0 0;
        text-decoration: none;
        text-align: center;
        font-size: 2rem;
        color: $sceneColor;
        text-decoration: none;
    }

        .controlButton.active {
            background-color: $currentSceneBG;
            color: #ffffff;
        }

        .controlButton .caption {
            font-size: 0.7rem;
            text-align: center;
        }

    .specialSources .specialSource {
        border: 4px solid $currentSceneBG;
        border-radius: 10px;
        padding: 5px;
        overflow: hidden;
        width: 3rem;
        height: 3.5rem;
        display: inline-block;
        margin: 5px 5px 0 0;
        text-decoration: none;
    }

        .specialSources .specialSource.muted {
            color: $sceneColor;
        }

        .specialSources .specialSource:not(.muted) {
            color: #ffffff;
            background-color: $currentSceneBG;
        }

        .specialSources .specialSource .icon {
            font-size: 2rem;
            text-align: center;
        }

        .specialSources .specialSource .name {
            font-size: 0.7rem;
            width: 100%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .specialSources .specialSource .volume {
            font-size: 0.7rem;
            width: 100%;
            white-space: nowrap;
        }

    .scenes .scene {
        border: 4px solid #00000000;
        border-radius: 10px;
        padding: 5px;
        margin-bottom: 5px;
        font-size: 1.3rem;
        max-height: calc(3em + 5px);
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        min-height: 2em;
        text-decoration: none;
        color: $sceneColor;
    }

        .scenes .scene.currentScene {
            background-color: $currentSceneBG;
            color: #ffffff;
            font-weight: bold;
        }

            .scenes .scene.currentScene:not(.previewScene) {
                border-color: $currentSceneBG;
            }

        .scenes .scene.previewScene {
            border-color: $previewSceneBG;
            color: #ffffff;
            font-weight: bold;
        }

            .scenes .scene.previewScene:not(.currentScene) {
                background-color: $previewSceneBG;
            }

        .scenes .scene:not(.previewScene):not(.currentScene) {
            border-color: $currentSceneBG;
        }

        .scenes .scene .sceneScreenshot {
            max-height: 2em;
            float: right;
            background-color: #000000;
        }

    .obsError {
        color: $errorColor;
    }

    input:disabled + label {
        color: #808080;
    }

    .scene.loading {
        animation: loadingAnimation alternate 0.5s ease infinite;
    }

    .scene.loadingPreview {
        animation: loadingAnimationPreview alternate 0.5s ease infinite;
    }

    @keyframes loadingAnimation {
        from {
            box-shadow: 0 0 1em $currentSceneBG;
        }

        to {
            box-shadow: 0 0 0.1em $currentSceneBG;
        }
    }

    @keyframes loadingAnimationPreview {
        from {
            box-shadow: 0 0 1em $previewSceneBG;
        }

        to {
            box-shadow: 0 0 0.1em $previewSceneBG;
        }
    }
</style>